module.exports = __webpack_public_path__ + "img/icon-funding-blue.aeeae99e.svg";